const BARTER_STATE = {
    proposal: 'PROPOSAL',
    valid: 'VALID',
    postponed: 'POSTPONED',
    finished: 'FINISHED'
}

export default BARTER_STATE